import DemoTravelRuleTableItem from './DemoTravelRuleTableItem'

export default DemoTravelRuleTableItem
